import './utils/flexible'; // 引入自定义的自适应配置
import { createApp } from 'vue'
import App from './App.vue'
import router from './router'

createApp(App)
  .use(router)
  .mount('#app')
